import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCustomerTheme } from "../Theme";
import { useModalContext } from "../components/ModalProvider";
import { useState } from "react";
import { Pivot, PivotItem } from "@fluentui/react";
import InfoList from "./InfoList";

class Properties {
    bridge: any;
}

export default function BridgeProperties(properties: Properties) {
    const { t } = useTranslation();
    const { theme } = useCustomerTheme();
    const navigate = useNavigate();
    const { pushError } = useModalContext() as any;
    const [tab, setTab] = useState('overview');

    console.log('properties in bridge >>>', properties);

    const selectTab = (value: any) => {
        const url = new URL(window.location.href);

        url.searchParams.set('tab', value.props.itemKey);
        window.history.replaceState(null, '', url.toString());

        setTab(value.props.itemKey);
    }

    const getConditionColor = (condition: string) => {
        switch (condition) {
            case '(5) nicht ausreichend':
                return 'red';
            default:
                return 'gray';
        }
    }

    return <div>
        <Pivot onLinkClick={selectTab} selectedKey={String(tab)}>
            <PivotItem itemKey="general" headerText={t('bridgePropertiesPanel.general')} itemIcon="Info">
                <div>
                    <div className="marginTopM">
                        <div className="textHeader">{properties.bridge.name || t('bridgePropertiesPanel.unnamedBridge')}</div>
                    </div>
                    <div className="marginTopM">
                        <InfoList list={[{
                            label: t('bridgePropertiesPanel.streetName'),
                            value: properties.bridge.streetName,
                        }, {
                            label: t('bridgePropertiesPanel.streetType'),
                            value: properties.bridge.streetType,
                        }, {
                            label: t('bridgePropertiesPanel.length'),
                            value: properties.bridge.length,
                            suffix: 'm',
                        }, {
                            label: t('bridgePropertiesPanel.width'),
                            value: properties.bridge.bridgeWidth,
                            suffix: 'm',
                        }, {
                            label: t('bridgePropertiesPanel.height'),
                            value: properties.bridge.bridgeHeight,
                            suffix: 'm',
                        }]}></InfoList>
                    </div>
                </div>
            </PivotItem>
            <PivotItem itemKey="construction" headerText={t('bridgePropertiesPanel.construction')} itemIcon="ConstructionCone">
                <div className="marginTopM">
                    <div className="textHeader">{t('bridgePropertiesPanel.structure')}</div>
                </div>
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.structureName'),
                        value: properties.bridge.structureName,
                    }, {
                        label: t('bridgePropertiesPanel.structureNumber'),
                        value: properties.bridge.structureNumber,
                    }]}></InfoList>
                </div>
                <div className="marginTopL">
                    <div className="textHeader">{t('bridgePropertiesPanel.construction')}</div>
                </div>
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.partialStructureType'),
                        value: properties.bridge.partialStructureType,
                    }]}></InfoList>
                </div>
                <div className="marginTopL">
                    <div className="textHeader">{t('bridgePropertiesPanel.material')}</div>
                </div>
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.constructionYear'),
                        value: properties.bridge.constructionYear,
                    }, {
                        label: t('bridgePropertiesPanel.bridgeMaterial'),
                        value: properties.bridge.bridgeMaterial,
                    }, {
                        label: t('bridgePropertiesPanel.materialClass'),
                        value: properties.bridge.materialClass,
                    }, {
                        label: t('bridgePropertiesPanel.materialSubStructure'),
                        value: properties.bridge.materialSubStructure,
                    }
                    ]}></InfoList>
                </div>
            </PivotItem>
            <PivotItem itemKey="traffic" headerText={t('bridgePropertiesPanel.traffic')} itemIcon="TrafficLight">
                <div className="marginTopM">
                    <div className="textHeader">{t('bridgePropertiesPanel.load')}</div>
                </div>
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.loadCapacityIndex'),
                        value: properties.bridge.loadCapacityIndex,
                    }, {
                        label: t('bridgePropertiesPanel.loadPositionOne'),
                        value: properties.bridge.loadPositionOne,
                    }, {
                        label: t('bridgePropertiesPanel.loadPositionTwo'),
                        value: properties.bridge.loadPositionTwo,
                    }]}></InfoList>
                </div>
                <div className="marginTopM">
                    <div className="textHeader">{t('bridgePropertiesPanel.usage')}</div>
                </div>
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.trafficAreaUsageDensity'),
                        value: properties.bridge.trafficAreaUsageDensity,
                    }, {
                        label: t('bridgePropertiesPanel.trafficHeavyVehicles'),
                        value: properties.bridge.trafficHeavyVehicles,
                    }, {
                        label: t('bridgePropertiesPanel.trafficVehicles'),
                        value: properties.bridge.trafficVehicles,
                    }, {
                        label: t('bridgePropertiesPanel.urbanArea'),
                        value: properties.bridge.urbanArea,
                    }, {
                        label: t('bridgePropertiesPanel.heavyTrafficBlock'),
                        value: properties.bridge.heavyTrafficBlock,
                    }]}></InfoList>
                </div>
            </PivotItem>
            <PivotItem itemKey="management" headerText={t('bridgePropertiesPanel.management')} itemIcon="Admin">
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.office'),
                        value: properties.bridge.office,
                    }, {
                        label: t('bridgePropertiesPanel.maintenanceOffice'),
                        value: properties.bridge.maintenanceOffice,
                    }]}></InfoList>
                </div>

                {properties.bridge.maintenanceOfficeDetails ?
                    <div className="marginTopM">
                        <div>
                            <div className="textHeader">{t('bridgePropertiesPanel.maintenanceOfficeDetails')}</div>
                        </div>
                        <div className="marginTopM">
                            <InfoList list={[{
                                label: t('bridgePropertiesPanel.type'),
                                value: properties.bridge.maintenanceOfficeDetails.type,
                            }, {
                                label: t('bridgePropertiesPanel.name'),
                                value: properties.bridge.maintenanceOfficeDetails.name,
                            }, {
                                label: t('bridgePropertiesPanel.state'),
                                value: properties.bridge.maintenanceOfficeDetails.state,
                            }, {
                                label: t('bridgePropertiesPanel.street'),
                                value: properties.bridge.maintenanceOfficeDetails.street,
                            }, {
                                label: t('bridgePropertiesPanel.postalCode'),
                                value: properties.bridge.maintenanceOfficeDetails.postalCode,
                            }, {
                                label: t('bridgePropertiesPanel.location'),
                                value: properties.bridge.maintenanceOfficeDetails.location,
                            }, {
                                label: t('bridgePropertiesPanel.phone'),
                                value: properties.bridge.maintenanceOfficeDetails.phone,
                            }, {
                                label: t('bridgePropertiesPanel.person'),
                                value: properties.bridge.maintenanceOfficeDetails.person,
                            }, {
                                label: t('bridgePropertiesPanel.branch'),
                                value: properties.bridge.maintenanceOfficeDetails.branch,
                            }, {
                                label: t('bridgePropertiesPanel.subsidiary'),
                                value: properties.bridge.maintenanceOfficeDetails.subsidiary,
                            }]}></InfoList>
                        </div>
                    </div>
                    :
                    <></>}
            </PivotItem>
            <PivotItem itemKey="risk" headerText={t('bridgePropertiesPanel.risk')} itemIcon="Warning">
                <div className="marginTopM">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.ageClass'),
                        value: properties.bridge.ageClass,
                    }, {
                        label: t('bridgePropertiesPanel.conditionGradeClass'),
                        value: properties.bridge.conditionGradeClass,
                    }, {
                        label: t('bridgePropertiesPanel.conditionGradeEvaluation'),
                        value: properties.bridge.conditionGradeEvaluation,
                        color: getConditionColor(properties.bridge.conditionGradeEvaluation),
                    }]}></InfoList>
                </div>
                <div className="marginTopL">
                    {properties.bridge.partOfBastList === 'NEIN' ?
                        <div className="textM">{t('bridgePropertiesPanel.notPartOfBastList')} <a href={t('bridgePropertiesPanel.bastListLink')} target="_blank" rel="noreferrer">BASt-Liste</a></div>
                        :
                        <div className="textM">{t('bridgePropertiesPanel.partOfBastList')} <a href={t('bridgePropertiesPanel.bastListLink')} target="_blank" rel="noreferrer">BASt-Liste</a></div>
                    }
                </div>
            </PivotItem>
            <PivotItem itemKey="projects" headerText={t('bridgePropertiesPanel.projects')} itemIcon="ProjectCollection">
                <div className="marginTopM">
                    <div className="textHeader">{t('bridgePropertiesPanel.projects')}</div>
                    {!properties.bridge.projects || properties.bridge.projects.length === 0 ?
                        <div className="textM marginTopM">{t('bridgePropertiesPanel.noProjects')}</div>
                        :
                        <div className="marginTopM">
                            <ol>
                                {properties.bridge.projects.map((project: any, index: number) => {
                                    return <li key={index} className="textM">
                                        <a href={project.link} target="_blank" rel="noreferrer">{project.project} {project.status}</a>
                                    </li>
                                })}
                            </ol>
                        </div>
                    }
                    {properties.bridge.germanRailwaysData ?
                        <div>
                            <img width={100} src={'/logos/deutsche-bahn.png'} alt={t('bridgePropertiesPanel.deutscheBahnAlt')} />
                            <div className="marginTopL textHeading">{t('bridgePropertiesPanel.germanRailwaysData')}</div>
                            <div className="marginTopM">
                                <InfoList list={[{
                                    label: t('bridgePropertiesPanel.description'),
                                    value: properties.bridge.germanRailwaysData.description,
                                }, {
                                    label: t('bridgePropertiesPanel.structure'),
                                    value: properties.bridge.germanRailwaysData.structure,
                                }, {
                                    label: t('bridgePropertiesPanel.area'),
                                    value: properties.bridge.germanRailwaysData.area,
                                }, {
                                    label: t('bridgePropertiesPanel.businessUnit'),
                                    value: properties.bridge.germanRailwaysData.businessUnit,
                                }, {
                                    label: t('bridgePropertiesPanel.region'),
                                    value: properties.bridge.germanRailwaysData.region,
                                }, {
                                    label: t('bridgePropertiesPanel.segment'),
                                    value: properties.bridge.germanRailwaysData.segment,
                                }, {
                                    label: t('bridgePropertiesPanel.track'),
                                    value: properties.bridge.germanRailwaysData.track,
                                }, {
                                    label: t('bridgePropertiesPanel.measures'),
                                    value: properties.bridge.germanRailwaysData.measures,
                                }]}></InfoList>
                            </div>
                        </div>
                        :
                        <></>}
                </div>
            </PivotItem>
        </Pivot>
    </div>;
}
